import { normalizeTemplate } from '../template-storage';

function createTemplateActions({ apiFetch, state, syncFromApi }) {
  const saveTemplate = async (payload, editingTemplate = null) => {
    const incomingId = payload?.id != null
      ? String(payload.id)
      : editingTemplate?.id != null
        ? String(editingTemplate.id)
        : '';
    const base = normalizeTemplate(editingTemplate || {});
    const nextTemplate = normalizeTemplate({
      ...base,
      ...(payload || {}),
      id: incomingId || base?.id,
    });
    if (!nextTemplate || !nextTemplate.n) return;

    const companyId = Number(state.activeCompanyId || state.currentUser?.company_id || 0);
    if (!companyId) throw new Error('Selecione uma empresa para salvar o modelo.');

    const body = {
      company_id: companyId,
      name: nextTemplate.n,
      description: nextTemplate.description || null,
      payment_type: nextTemplate.paymentType || 'mass',
      file_type: nextTemplate.fileType || null,
      delimiter: nextTemplate.sep || null,
      reconciliation: nextTemplate.strat || 'BY_CPF',
      identifier_field_mode: nextTemplate.identifierFieldMode || null,
      identifier_field_location: nextTemplate.identifierFieldLocation || null,
      allowed_users: Array.isArray(nextTemplate.allowedUsers) ? nextTemplate.allowedUsers : [],
      active: nextTemplate.ativo !== false,
    };

    if (incomingId) {
      await apiFetch(`/api/templates/${incomingId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      });
    } else {
      await apiFetch('/api/templates', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    }
    await syncFromApi(undefined, 'templates');
  };

  const deleteTemplate = async (templateId) => {
    const id = String(templateId ?? '').trim();
    if (!id) throw new Error('Identificador do modelo ausente.');
    await apiFetch(`/api/templates/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
    await syncFromApi(undefined, 'templates');
  };

  return { saveTemplate, deleteTemplate };
}

export { createTemplateActions };
